import { useQuery } from '@tanstack/react-query';
import { fetchCities } from '../../apis/profile';

const useCities = (country: string) => {
  return useQuery({
    queryKey: ['cities', country],
    queryFn: async () => {
      const response = await fetchCities(country);
      return response?.data || [];
    },
    enabled: !!country,
  });
};

export default useCities;
